import script from "./DeleteDashboardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteDashboardModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteDashboardModal.vue?vue&type=style&index=0&id=500e53eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500e53eb"]])

export default __exports__